import { useId, type ReactNode } from 'react';

const ROW = 'flex min-h-12 items-center justify-between gap-3 py-1.5 md:min-h-10';

type Props = {
  label: ReactNode;
  children: ReactNode;
} & (
  | { group?: false; info?: never }
  | {
      /**
       * The control is a group of buttons rather than a single input. A <label> around buttons would
       * name and click the first button, so the row becomes a labelled group instead.
       */
      group: true;
      /** Next to the label, e.g. an InfoTip. Group rows only: inside a <label> it would take its clicks. */
      info?: ReactNode;
    }
);

/** A labelled control: label on the left, control on the right. Rows are tall enough to tap. */
export function FieldRow({ label, children, group, info }: Props) {
  const id = useId();
  if (group) {
    return (
      <div className={ROW} role="group" aria-labelledby={id}>
        <span className="flex items-center gap-0.5">
          <span id={id}>{label}</span>
          {info}
        </span>
        {children}
      </div>
    );
  }
  return (
    <label className={ROW}>
      <span>{label}</span>
      {children}
    </label>
  );
}
